import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";

import SelectOffPath from '../../../Image/GrayDownArrow.png';

export default function ScoreRuleKeywordSelectBox(props) {
  const { index, value, setValue } = props;

  const [isClicked, setIsClicked] = useState(false);
  
  const TotalRef = useRef();
  const SelectListRef = useRef();

  const options = [
    'Not Scored',
    'Time',
    'Reps',
    'Rounds + Reps',
    'Distance',
    'Weight',
    'Point',
    'Peek Watt',
    'Max Speed'
  ];

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [onClickOutSide])
  
  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  function onClickOutSide(e) {
    if (TotalRef.current !== e.target && !TotalRef.current.contains(e.target)) {
      setIsClicked(false);
    }
  }

  // 선택된 데이터 텍스트 표출 //
  function decideValueText() {
    if (value === 'Not Scored') return '점수 없음';
    else if (value === 'Time') return '시간';
    else if (value === 'Reps') return '렙수';
    else if (value === 'Rounds + Reps') return '라운드 + 렙수';
    else if (value === 'Distance') return '거리';
    else if (value === 'Weight') return '무게';
    else if (value === 'Point') return '포인트';
    else if (value === 'Peek Watt') return '피크와트';
    else if (value === 'Max Speed') return '최고 속도';
  }

  // 셀렉트 박스 텍스트 결정 //
  function decideOptionText(data) {
    if (data === 'Not Scored') return '점수 없음';
    else if (data === 'Time') return '시간';
    else if (data === 'Reps') return '렙수';
    else if (data === 'Rounds + Reps') return '라운드 + 렙수';
    else if (data === 'Distance') return '거리';
    else if (data === 'Weight') return '무게';
    else if (data === 'Point') return '포인트';
    else if (data === 'Peek Watt') return '피크와트';
    else if (data === 'Max Speed') return '최고 속도';
  }

  // 셀렉트 박스 클릭시 //
  function onClickSelectBox() {
		if (isClicked) {
			setIsClicked(false);
		}
		else {
			setIsClicked(true);
		}
  }

  // 수업 선택시 //
  function onClickSelectList(data) {
    setValue(data, index);

    setIsClicked(false);
  }

  return (
    <SelectBoxWrapper ref={TotalRef}>
      <SeletedBox onClick={onClickSelectBox}>
          <SelectBoxTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='pointer'>{decideValueText()}</Text>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#B2B2B2' hover='pointer'>{value}</Text>
          </SelectBoxTextWrapper>
        <ArrowImage src={SelectOffPath} isClicked={isClicked}/>
      </SeletedBox>
      <WillSelectList ref={SelectListRef} isClicked={isClicked}>
        {
          options.map((data, index) => (
            <SelectListTextWrapper 
              key={'CustomTag-' + index}
              isClicked={isClicked}
              onClick={() => onClickSelectList(data)}>
              {decideOptionText(data)}
            </SelectListTextWrapper>
          ))
        }
      </WillSelectList>
    </SelectBoxWrapper>
  )
}

const SelectBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;
`;

const SeletedBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 15px;

  width: calc(100% - 32px);
  height: calc(100% - 2px);

  border: 1px solid #CBCBCB;
  border-radius: 30px;
  background-color: #2F2F32;

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const ArrowImage = styled.img`
  width: 17px;
  height: 10px;

  transform: ${props => props.isClicked ? `rotate(-180deg)` : `rotate(0deg)`};

  transition: all 0.3s ease-in-out;
`;

const WillSelectList = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 40px;

  width: 100%;
  height: ${props => props.isClicked ? `306px` : `0px`};

  border: ${props => props.isClicked ? `1px solid #CBCBCB` : `0px`};
  border-radius: 6px;

	overflow: hidden;

  // z-index: 80;

	:hover {
		cursor: pointer;
	}

	&::-webkit-scrollbar {
		// width: 9px;
		width: 0px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px #FF8B48;
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}

  transition: all 0.3s ease-in-out;
`;

const SelectBoxTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 80%;
  height: 21px;

  gap: 10px;

  overflow: hidden;
`;

const SelectListTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 0px 10px;

  width: calc(100% - 20px);
  min-height: 34px;

  overflow: hidden;
  
  background-color: #2F2F32;

  font-family: Poppins-Medium;
  font-size: 14px;

  color: #FFFFFF;

  :hover {
    cursor: pointer;
    background-color: #4E8168;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;